import React from 'react';
import {  RouterProvider} from 'react-router-dom';
import Fallback from './pages/Fallback/Fallback';
import {router} from './route/AppRoutes';

function App() {
  return (
     <RouterProvider router={router} fallbackElement={<Fallback />} />
  );
}

export default App;
